var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layout.show.app)?_c('div',{staticClass:"tool-foot",class:{'has-margin': _vm.layout.spacing > 0},style:({paddingRight: _vm.margin, paddingBottom: _vm.margin})},[_vm._v(" generated with geekgroup.app ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }